const mutations = {
    setInventoryMode(state, data) {
        state.inventoryMode = data
    },

    setInventoryContentPersonal(state, data) {
        state.inventoryContentPersonal = data
    },

    setInventoryPersonal(state, data) {
        state.inventoryPersonal = data
    },

    setInventoryTotal(state, data) {
        state.inventoryTotal = data
    },

    addToTotalInventory(state, data) {
        if(state.inventoryTotal !== null) {
            state.inventoryTotal.data.push(data)
            state.inventoryTotal.totalPrice += data.price
        }
    },

    addToPersonalInventory(state, data) {
        if(state.inventoryPersonal !== null) {
            state.inventoryPersonal.data.push({itemNo: data.itemNo, amount: data.amount, type: data.type})
        }
    },

    removeFromPersonalInventory(state, data) {
        state.inventoryPersonal.data = state.inventoryPersonal.data.filter(el => {
            if(el.itemNo === data.itemNo && el.type === data.type) {
                state.inventoryPersonal.totalPrice -= el.price
                return false
            }
            else {
                return el
            }
        })
    },

    removeFromTotalInventory(state, data) {
        state.inventoryTotal.data = state.inventoryTotal.data.filter(el => {
            if(el.itemNo === data.itemNo && el.type === data.type && el.uid === data.uid) {
                state.inventoryTotal.totalPrice -= el.price
                return false
            }
            else {
                return el
            }
        })
    },

    setInventoryDrawerState(state, data) {
        state.inventoryDrawer = data
    },

    setInventoryAvailable(state, data) {
        state.inventoryAvailable = data
        if(data === false) {
            state.inventoryMode = false
        }
    }
}

export default mutations
